import React, { createElement, useEffect, useRef, useState } from 'react'
import { ChakraProvider, extendTheme } from "@chakra-ui/react"
import { TinyColor } from '@ctrl/tinycolor';
// import sample from 'lodash/sample'

import "@fontsource/noto-serif-tc/400.css"
import "@fontsource/noto-serif-tc/500.css"
import "@fontsource/noto-serif-tc/700.css"

import customTheme from "./theme"
import colors from './colors'
// import RouteProgress from '../../components/RouteProgress'
// import { WAITING_LIST_AB_TEXT } from '../../constants/storage'
// import Link from '../../components/Link';

export const getTheme = ({ theme, fontFamily }) => {
  const themeColors = colors[theme]
  const getColor = pos => {
    const key = themeColors[pos]
    return typeof key === 'number' ? customTheme.colors[theme][key] : key
  }
  return themeColors ? {
    colors: {
      primary: {
        50: new TinyColor(getColor('light')).lighten(20).toString(),
        200: getColor('light'),
        500: getColor('base'),
        600: getColor('base'),
      },
      custom: {
        bg: customTheme.colors[theme][50],
        primary: getColor('base'),
        text: getColor('text'),
      },
    },
    fonts: {
      body: customTheme.fonts[fontFamily],
      heading: customTheme.fonts[fontFamily],
    },
    styles: {
      global: {
        body: {
          bg: '#f8f8f8',
          color: 'custom.text',
        },
      }
    }
  } : {}
}

const Provider = ({ children, override = {} }) => {
  useEffect(() => {
    if (override.fontFamily === 'sans') {
      Promise.all([
        import("@fontsource/noto-sans-tc/400.css"),
        import("@fontsource/noto-sans-tc/500.css"),
        import("@fontsource/noto-sans-tc/700.css"),
      ])
    }
    if (override.fontFamily === 'serif') {
      Promise.all([
        import("@fontsource/noto-serif-tc/400.css"),
        import("@fontsource/noto-serif-tc/500.css"),
        import("@fontsource/noto-serif-tc/700.css"),
      ])
    }
  }, [override.fontFamily])
  return (
    <ChakraProvider
      resetCSS
      theme={extendTheme(
        customTheme,
        { colors: { primary: customTheme.colors.teal } },
        getTheme(override),
      )}
    >
      {children}
    </ChakraProvider>
  )
}

export default Provider


const PageWithProvider = ({ Page, ...props }) => {
  // useEffect(() => {

  //   const messages = [
  //     `喜歡 {name} 的頁面嗎？自己做一個吧！`,
  //     `{name} 今天用了傳送門，你呢？`,
  //     `立即取得你的傳送門~`,
  //   ]
  //   const abMessage = window.sessionStorage.getItem(WAITING_LIST_AB_TEXT) || sample(messages)
  //   window.sessionStorage.setItem(WAITING_LIST_AB_TEXT, abMessage)
  //   // const isHidden = props.data?.['waiting-list']?.isHidden
  //   document.querySelectorAll('.footer-waiting-list').forEach(ele => {
  //     ele.setAttribute('href', `/${props.data.slug}/waiting-list`)
  //     // ele.setAttribute('href', isHidden ? `/waiting-list` : `/${props.data.slug}/waiting-list`)
  //     if (ele.dataset.name === 'text') {
  //       ele.innerText = abMessage.replace('{name}', props.data.name)
  //     }
  //   })
  // }, [props.data])
  return (
    <Provider override={getTheme(props.data)}>
      {createElement(Page, props)}
    </Provider>
  )
}

// export const withProvider = Page => {
//   PageWithProvider.defaultProps = {
//     Page,
//   }
//   return PageWithProvider
// }

export const withProvider = Page => props => <PageWithProvider {...props} Page={Page} />
